export const HERO_CONSTANTS = {
  TAG: "Home Decor",
  DATE: "October 23, 2023",
  TITLE: "Transform Your Bedroom with Luxurious Bouclé Beds",
  DESCRIPTION:
    "Discover the elegance and comfort of bouclé beds, a perfect addition to any modern bedroom. Learn how these stylish beds can elevate your home decor.",
  HERO_IMAGE:
    "https://images.pexels.com/photos/1454806/pexels-photo-1454806.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
};

export const ARTICLE_SUMMARY = [
  "Bouclé beds are gaining popularity in the world of interior design, known for their unique texture and luxurious appearance. This guide explores the benefits and styling tips for incorporating bouclé beds into your bedroom decor.",
  "From their soft, looped fabric to their versatile design, bouclé beds offer both comfort and aesthetic appeal. We'll delve into the various styles available and how to choose the perfect bouclé bed for your space.",
  "Whether you're redecorating your bedroom or looking for a statement piece, bouclé beds provide a chic and cozy option. Let's explore the features and advantages of these elegant beds.",
];

export const ARTICLE_STEPS = [
  {
    title: "1. Understanding Bouclé Fabric",
    content:
      "Bouclé fabric is characterized by its looped, curly texture, which adds a unique and tactile element to furniture. This fabric is not only stylish but also durable and easy to maintain, making it an excellent choice for beds.",
  },
  {
    title: "2. Choosing the Right Bouclé Bed",
    content:
      "When selecting a bouclé bed, consider factors such as size, color, and design. Bouclé beds come in various styles, from minimalist to mid-century modern, allowing you to find the perfect match for your bedroom decor.",
  },
  {
    title: "3. Styling Tips for Bouclé Beds",
    content:
      "To enhance the look of your bouclé bed, pair it with complementary bedding and accessories. Neutral tones and natural materials work well with bouclé fabric, creating a cohesive and inviting space.",
  },
  {
    title: "4. Maintenance and Care",
    content:
      "Bouclé fabric is relatively low-maintenance, but regular cleaning is essential to keep it looking its best. Vacuum your bouclé bed regularly and spot clean any spills with a mild detergent.",
  },
  {
    title: "5. Benefits of Bouclé Beds",
    content:
      "Bouclé beds offer several benefits, including comfort, durability, and aesthetic appeal. Their unique texture adds depth and interest to your bedroom, making them a standout piece in any decor.",
  },
  {
    title: "6. Where to Buy Bouclé Beds",
    content:
      "Bouclé beds are available from various retailers, both online and in-store. Look for reputable brands that offer high-quality bouclé fabric and sturdy bed frames to ensure you get the best value for your investment.",
  },
];

export const RELATED_ARTICLES = [
  {
    image:
      "https://images.pexels.com/photos/1454807/pexels-photo-1454807.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 20, 2023",
    title: "Top Trends in Bedroom Furniture for 2023",
    description:
      "Explore the latest trends in bedroom furniture, from bouclé beds to minimalist designs. Discover how to create a stylish and comfortable bedroom with the newest decor ideas.",
  },
  {
    image:
      "https://images.pexels.com/photos/1454808/pexels-photo-1454808.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 15, 2023",
    title: "How to Choose the Perfect Bed for Your Home",
    description:
      "Learn how to select the ideal bed for your home, considering factors such as size, style, and material. Our guide covers everything you need to know to make an informed decision.",
  },
  {
    image:
      "https://images.pexels.com/photos/1454809/pexels-photo-1454809.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 12, 2023",
    title: "Creating a Cozy Bedroom Retreat",
    description:
      "Transform your bedroom into a cozy retreat with our tips on choosing the right furniture, bedding, and decor. Discover how to create a relaxing and inviting space.",
  },
];

export const FOOTER_CONSTANTS = {
  CTA_TITLE: "Upgrade Your Bedroom with Bouclé Beds",
  CTA_BACKGROUND:
    "https://images.pexels.com/photos/1454810/pexels-photo-1454810.jpeg",
  EMAIL_PLACEHOLDER: "Enter your email address",
  BUTTON_TEXT: "Shop Now",
  COPYRIGHT: " 2024 Home Decor. All rights reserved",
};
